import Vue from 'vue'
import ElementUI from 'element-ui'
import VueLazyload from 'vue-lazyload'

import App from './App.vue'
import router from './router'
import store from './store'
import middleware from './middlewares'
import AppDialog from './components/AppDialog'
import AppDialog2 from './components/AppDialog2'
import AppUpload from './components/AppUpload'
import MultiUpload from './components/MultiUpload'
import filters from './filters'
import './permission'

import '@/assets/styles/index.scss'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(middleware)
Vue.use(filters)
Vue.use(VueLazyload)
Vue.use(AppDialog)
Vue.use(AppDialog2)
Vue.use(AppUpload)
Vue.use(MultiUpload)

const webpSupport = document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0

window.webpSupport = webpSupport
Vue.prototype.webpSupport = webpSupport

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
